const getIconName = (type) => {
  if (type === 'Kickoff') {
    return 'icon-announcement';
  }
  if (type === 'Pass_success') {
    return 'icon-info';
  }
  if (['Goal', 'Free_kick_hit', 'Goal_with_assist', 'Penalty_successful'].includes(type)) {
    return 'icon-ball-green';
  } else if(['Penalty_missed'].includes(type)){
    return 'icon-ball-red';
  }
  return 'icon-announcement';
}

export default ({ report }) => (`
  ${report?.map((item, index) => `
  <div class="timeline js-timeline-item d-flex ${index === 0 ? 'new' : 'old'}" data-audio="${item.audio||''}">
    <div class="timeline__type">
        <i class="${getIconName(item.actiontype)}"></i>
    </div>
    <div class="timeline__content d-flex flex-column">
        <div class="timeline__title">
            ${item.action_name} ${['Goal', 'Penalty_successful', 'Goal_with_assist', 'Free_kick_hit'].includes(item.actiontype) ? `(${item.goals})` : ''}
        </div>
        <div class="timeline__description">
            ${item.message}
        </div>
        <div class="timeline__date">
            ${item.minute}’
        </div>
    </div>
  </div>
  `).join('')}
`);
